import { __assign, __awaiter, __generator } from "tslib";
import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import { Text, Box, Loader } from 'wix-style-react';
import { SolutionGridWrapper, } from '../../solution-grid-wrapper/solution-grid-wrapper';
import { getTagsDataBySlugs } from '../../../api/api';
import { useConfigContext } from '../../../config-context';
import { HolidaySaleHeader } from './holiday-sale-header';
import { biLogger } from '../../../bi';
import { getWebSolutionsBiData } from '../../home/biData';
export var HolidaySale = composer()
    .withMarketplaceStore()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var t = _a.t, market = _a.market, marketplaceStore = _a.marketplaceStore, experiments = _a.experiments;
    // tslint:disable-next-line:react-hooks-nesting
    var _b = useConfigContext(), locale = _b.locale, countryCode = _b.countryCode;
    // tslint:disable-next-line:react-hooks-nesting
    var _c = React.useState([]), solutions = _c[0], setSolutions = _c[1];
    // tslint:disable-next-line:react-hooks-nesting
    var _d = React.useState(false), isFetching = _d[0], setIsFetching = _d[1];
    var loadSolutionsBySlug = function (
    // tslint:disable-next-line:no-shadowed-variable
    locale, 
    // tslint:disable-next-line:no-shadowed-variable
    countryCode) {
        if (locale === void 0) { locale = 'en'; }
        if (countryCode === void 0) { countryCode = 'us'; }
        return __awaiter(void 0, void 0, void 0, function () {
            var tagsData;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsFetching(true);
                        return [4 /*yield*/, getTagsDataBySlugs(['pre-holiday-sale'], false, locale, countryCode, true, true)];
                    case 1:
                        tagsData = _b.sent();
                        setSolutions((_a = tagsData === null || tagsData === void 0 ? void 0 : tagsData.webSolutions) === null || _a === void 0 ? void 0 : _a.map(function (solution) {
                            return __assign({}, solution === null || solution === void 0 ? void 0 : solution.baseInfo);
                        }));
                        setIsFetching(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    var getHolidaySaleGridProps = function (
    // tslint:disable-next-line:no-shadowed-variable
    solutions) {
        var solutionsBiData = getWebSolutionsBiData(solutions, 'box', 'pre-holiday-sale', marketplaceStore.metaSiteId, marketplaceStore.route, marketplaceStore.prevRoute, marketplaceStore.bundleApps);
        // tslint:disable-next-line:no-shadowed-variable
        var solutionGridWrapperProps = {
            solutions: solutions,
            isFull: true,
            numberOfLines: 4,
            referralSectionName: 'pre-holiday-sale',
            solutionsBiData: solutionsBiData,
        };
        return solutionGridWrapperProps;
    };
    var solutionGridWrapperProps = getHolidaySaleGridProps(solutions);
    // tslint:disable-next-line:react-hooks-nesting
    React.useEffect(function () {
        loadSolutionsBySlug(locale, countryCode);
        biLogger.appMarketAppCollectionImpressions({
            tag_name: 'pre-holiday-sale',
            tag_type: 'homepage',
            msid: marketplaceStore.metaSiteId,
            market: market,
        });
    }, []);
    var showNewContent = experiments.enabled('specs.marketplace.blackFridaySaleContent');
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { height: '41px' }),
        React.createElement(Box, { direction: 'vertical', padding: '24px 48px 51px', background: 'linear-gradient(to bottom, #0b132b, #0b132b 204px, #f0f4f7 204px, #f0f4f7 469px)' },
            React.createElement(Box, { direction: 'vertical', alignSelf: 'center', maxWidth: '1248px', width: "100%" },
                React.createElement(HolidaySaleHeader, { showNewContent: showNewContent })),
            !showNewContent && (React.createElement(React.Fragment, null,
                React.createElement(Box, { height: '9px' }),
                isFetching ? (React.createElement(LoaderSale, null)) : (React.createElement(Box, { direction: 'vertical', alignSelf: 'center', maxWidth: '1248px', width: "100%" },
                    React.createElement(SolutionGridWrapper, __assign({}, solutionGridWrapperProps)),
                    React.createElement(Box, { verticalAlign: 'space-between', align: 'center', marginBottom: '-24px' },
                        React.createElement(Disclaimer, null)))))))));
});
var LoaderSale = function () { return (React.createElement(Box, { width: "100%", height: '495px', align: "center", verticalAlign: 'middle', color: 'red' },
    React.createElement(Loader, { status: 'loading', size: 'small', color: 'white' }))); };
var Disclaimer = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return (React.createElement(Text, { skin: "standard", secondary: true, weight: "normal", size: "tiny" },
        ' ',
        t('home.holidaySale.disclaimer'),
        ' '));
});
//# sourceMappingURL=holiday-sale.js.map